export const informationSystemsConst = {
  path: "/single-programs/information-systems",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ИНФОРМАЦИОННЫЕ СИСТЕМЫ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Информационные системы — фундамент цифровой инфраструктуры</h2>
      <p>
        Каждая современная организация — от международной корпорации до клиники или университета — нуждается в устойчивых, эффективных и
        безопасных информационных системах. Программа готовит специалистов, которые умеют проектировать, внедрять и сопровождать такие
        системы с учётом потребностей бизнеса и технологий будущего.
      </p>
      <p>
        Это образование на стыке программирования, анализа данных, архитектуры систем и управления проектами. Выпускники становятся
        универсальными IT-профессионалами, способными строить цифровую экосистему любой сложности.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Архитектура информационных систем</li>
        <li>Базы данных и SQL</li>
        <li>Проектирование пользовательского интерфейса (UI/UX)</li>
        <li>Информационная безопасность систем</li>
        <li>Управление проектами и Agile-методологии</li>
        <li>DevOps и сопровождение жизненного цикла ПО</li>
        <li>Веб-сервисы и облачные технологии</li>
        <li>Анализ бизнес-процессов и автоматизация</li>
        <li>Системная интеграция и техническая документация</li>
        <li>Практика на реальных кейсах и стажировки в IT-компаниях</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Системный аналитик</li>
        <li>Архитектор информационных систем</li>
        <li>IT-консультант</li>
        <li>Инженер по внедрению и поддержке ПО</li>
        <li>Специалист по автоматизации бизнес-процессов</li>
        <li>Администратор информационных систем</li>
        <li>Руководитель IT-проектов</li>
        <li>Бизнес-аналитик</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €90,000 в год,</strong> в зависимости от профиля и отрасли.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом международного уровня</li>
        <li>Гибкий график: очно или дистанционно, на русском или английском языке</li>
        <li>Преподаватели-практики из ИТ-компаний</li>
        <li>Современные инструменты обучения: виртуальные лаборатории, симуляторы, работа в командах</li>
        <li>Доступ к международным сертификациям (ITIL, PMP, PMI)</li>
        <li>Индивидуальное сопровождение от поступления до трудоустройства</li>
      </ul>
      <p>
        Информационные системы — это карьера, которая открывает путь в любую отрасль: от финансов до медицины, от образования до госсектора.
      </p>
      <h2>Как поступить?</h2>
      <p>Поступление — это просто. Наши специалисты приёмной комиссии помогут вам на каждом этапе: от выбора программы до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Информационные системы — фундамент цифровой инфраструктуры
    Каждая современная организация — от международной корпорации до клиники или университета — нуждается в устойчивых, эффективных и безопасных информационных системах. Программа готовит специалистов, которые умеют проектировать, внедрять и сопровождать такие системы с учётом потребностей бизнеса и технологий будущего.
    Это образование на стыке программирования, анализа данных, архитектуры систем и управления проектами. Выпускники становятся универсальными IT-профессионалами, способными строить цифровую экосистему любой сложности.

    Что вы будете изучать?
    • Архитектура информационных систем
    • Базы данных и SQL
    • Проектирование пользовательского интерфейса (UI/UX)
    • Информационная безопасность систем
    • Управление проектами и Agile-методологии
    • DevOps и сопровождение жизненного цикла ПО
    • Веб-сервисы и облачные технологии
    • Анализ бизнес-процессов и автоматизация
    • Системная интеграция и техническая документация
    • Практика на реальных кейсах и стажировки в IT-компаниях


    Кем можно работать после окончания?
    • Системный аналитик
    • Архитектор информационных систем
    • IT-консультант
    • Инженер по внедрению и поддержке ПО
    • Специалист по автоматизации бизнес-процессов
    • Администратор информационных систем
    • Руководитель IT-проектов
    • Бизнес-аналитик

    Средний доход в Европе:
    от €50,000 до €90,000 в год, в зависимости от профиля и отрасли.

    Почему выбирают нас?
    • Европейский диплом международного уровня
    • Гибкий график: очно или дистанционно, на русском или английском языке
    • Преподаватели-практики из ИТ-компаний
    • Современные инструменты обучения: виртуальные лаборатории, симуляторы, работа в командах
    • Доступ к международным сертификациям (ITIL, PMP, PMI)
    • Индивидуальное сопровождение от поступления до трудоустройства

    Информационные системы — это карьера, которая открывает путь в любую отрасль: от финансов до медицины, от образования до госсектора.

    Как поступить?
    Поступление — это просто. Наши специалисты приёмной комиссии помогут вам на каждом этапе: от выбора программы до подачи заявки.
  `,
};
